/* eslint-disable max-len */
import { Component } from 'react';

class AboutContainer extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="about-container__background">
        <div className="about-container row">

          <h1>Over ons</h1>
          <p>
            <span className="bold">Looptijdrente.nl</span> wordt u gratis aangeboden door de Nationale Hypotheekbond.
           Met deze website willen wij de transparantie in de financiële dienstverlening bevorderen.

           Voor geldverstrekkers en intemerdiairs bieden wij de looptijdrenteberekeningen ook aan als API of als websitetool.
            Als u daarin interesse heeft, neemt u dan contact op met Jos van Driesum via telefoonnummer <span className="bold">06-44081447</span> of via email: <span className="bold">j.vandriesum@hypotheekbond.nl</span>
         </p>
        </div>
      </div>

    );
  }
}

export default AboutContainer;
